// resource毎に表示が結構異なりそうなので、Rowをcomponentで切り出して、
// resourceごとの個別要件に対応しやすいようにしておく。

// custom
import { NitoelTRow, NitoelTBodyCell } from "components/atoms/NitoelTable";
import NitoelHelpIcon from "components/atoms/NitoelHelpIcon";
import { SpecificPermission, PermissionCheckBox } from "./RoleCheckBox";
import Stack from "@mui/material/Stack";
import { ResourceType } from "../RoleForm";
import { useDict } from "lib/dict";

type RowProps = {
  resource: ResourceType;
  permissions: any;
  togglePermission: (resource_key: string, permission_key: string) => void;
  disabled?: boolean;
};

// quotationはwrite権限がotherのquotation_apply, quotation_proceedに分割されているので、
// その権限をwriteの列に表示するようにしている。
const QuotationRow = (props: RowProps): React.JSX.Element => {
  const { resource, permissions, togglePermission, disabled = false } = props;
  const { d } = useDict();
  const displayName = resource.nameKey ? d(resource.nameKey) : resource.name;
  return (
    <>
      <NitoelTRow>
        <NitoelTBodyCell padding="none">
          {displayName}
          <NitoelHelpIcon resource="role" helpKey={resource.key} />
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          <PermissionCheckBox
            permissions={permissions}
            resourceKey={resource.key}
            permission="read"
            togglePermission={togglePermission}
            disabled={disabled}
          />
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          {resource.others.map((other, idx) => (
            <SpecificPermission
              key={idx}
              checked={permissions[resource.key][other.value] == 1}
              handleChange={() => togglePermission(resource.key, other.value)}
              label={other.label}
              helpKey={other.value}
              disabled={disabled}
            />
          ))}
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          <PermissionCheckBox
            permissions={permissions}
            resourceKey={resource.key}
            permission="export"
            togglePermission={togglePermission}
            disabled={disabled}
          />
        </NitoelTBodyCell>
      </NitoelTRow>
    </>
  );
};

const StandardRow = (props: RowProps): React.JSX.Element => {
  const { resource, permissions, togglePermission, disabled = false } = props;
  const { d } = useDict();
  const displayName = resource.nameKey ? d(resource.nameKey) : resource.name;
  return (
    <>
      <NitoelTRow>
        <NitoelTBodyCell padding="none">
          {displayName}
          <NitoelHelpIcon resource="role" helpKey={resource.key} />
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          {/* read の項目を持たない resource（BCP。write を持つ人だけが使う）は、保存済みの read があっても出さない */}
          {resource.permissions.includes("read") ? (
            <PermissionCheckBox
              permissions={permissions}
              resourceKey={resource.key}
              permission="read"
              togglePermission={togglePermission}
              disabled={disabled}
            />
          ) : (
            <Stack ml={2.5}>-</Stack>
          )}
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          <PermissionCheckBox
            permissions={permissions}
            resourceKey={resource.key}
            permission="write"
            togglePermission={togglePermission}
            disabled={disabled}
          />
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          <PermissionCheckBox
            permissions={permissions}
            resourceKey={resource.key}
            permission="export"
            togglePermission={togglePermission}
            disabled={disabled}
          />
        </NitoelTBodyCell>
        <NitoelTBodyCell padding="none">
          {resource.others.map((other, idx) => (
            <SpecificPermission
              key={idx}
              checked={permissions[resource.key][other.value] == 1}
              handleChange={() => togglePermission(resource.key, other.value)}
              label={other.label}
              helpKey={other.value}
              disabled={disabled}
            />
          ))}
        </NitoelTBodyCell>
      </NitoelTRow>
    </>
  );
};

const FormRow = (props: RowProps): React.JSX.Element => {
  if (props.resource.key === "quotation") {
    return <QuotationRow {...props} />;
  }

  return <StandardRow {...props} />;
};

export default FormRow;
